export const Role = {
  admin: 'admin',
  editor: 'editor',
}

export const userIsAdmin = () => {
  return hasRole([Role.admin]);
}

/**
 * Checks whether the user has at least one role.
 *
 * @param {Array} roles
 *
 * @returns {boolean}
 */
export function hasRole(roles) {
  if (!Array.isArray(roles)) {
    return false
  }

  let userRoles = (window?.userRoles || '').split(',').filter(i => i.length > 0).map(r => r.toLowerCase());

  for (const item of roles) {
    if (userRoles.some(role => role === item)) {
      return true;
    }
  }

  return false;
}

export const getUserProfile = () => {
  let data = {};
  $.ajax({
    async: false,
    url: '/api/user.json',
    type: 'GET',
    dataType: 'json',
    success: function (resp) {
      data = resp;
    },
    error: function (){
      data = {};
    }
  });

  return data;
}
